const regionConfig = (region) => {
  const startingPositions = {
    africa: {
      center: [4.448097, 21.711848],
      zoom: 3.5,
      bounds: [[45.86134651795265, 62.501718180753706],
       [-39.25067998385366, -19.03653252482007]]
    },

    northAm: {
      center: [45.9507, -100.6531],
      zoom: 3.6,
      bounds: [[80.25969372864783,-33.90841997046446],
      [-13.442078738122425, -175.49878680705257]]
    },

    asiaPac: {
      center: [5.560749, 118.344816],
      zoom: 2.9,
      bounds: [[60.828780290572546,180.21636217430736]
    ,[-54.95098679706429, 56.62748477559099]]
    },

    europe: {
      center: [51.586013, 41.704757],
      zoom: 2.9,
    },

    latAm: {
      center: [-14.3, -74.2],
      zoom: 3.3,
      bounds: [
        [-65.6267446447533, -133.83593750000003],
        [46.96479793033104, -14.523437500000004],
      ],
    },

    middleEast: {
      center: [30.722906, 43.972538],
      zoom: 4.5,
      bounds: [[48.726621208770254, 64.36615988896042],
        [8.686486207445412, 23.597034536173517]
        ]
    },
  };

  return {
    startingPosition: startingPositions[region]
      ? {
          center: startingPositions[region].center,
          zoom: startingPositions[region].zoom,
        }
      : { center: [0, 0], zoom: 3 },
    bounds: startingPositions[region]
      ? startingPositions[region].bounds
      : null,
  };
};

export default regionConfig;
